import { computed, ref } from 'vue'

const pendingRequests = ref(0)
const showLoading = ref(false)

const LOADING_DELAY_MS = 200
// Evita "titileo" entre requests secuenciales: cuando se muestra, lo mantenemos un mínimo
// y al finalizar esperamos un pequeño delay antes de ocultar (si otro request arranca, se cancela).
const LOADING_MIN_VISIBLE_MS = 400
const LOADING_HIDE_DELAY_MS = 250
let showTimerId = null
let hideTimerId = null
let visibleSinceMs = 0

const isGlobalLoading = computed(() => pendingRequests.value > 0)
const isGlobalLoadingVisible = computed(() => showLoading.value)

function scheduleShowIfNeeded() {
  if (showLoading.value) return
  if (showTimerId) return

  showTimerId = globalThis.setTimeout(() => {
    showTimerId = null
    if (pendingRequests.value > 0) {
      showLoading.value = true
      visibleSinceMs = Date.now()
    }
  }, LOADING_DELAY_MS)
}

function hideNow() {
  if (showTimerId) {
    globalThis.clearTimeout(showTimerId)
    showTimerId = null
  }
  if (hideTimerId) {
    globalThis.clearTimeout(hideTimerId)
    hideTimerId = null
  }
  showLoading.value = false
}

function scheduleHideIfNeeded() {
  if (hideTimerId) return

  // Si nunca llegó a mostrarse, ocultamos sin esperar.
  if (!showLoading.value) {
    hideNow()
    return
  }

  const elapsed = Date.now() - (visibleSinceMs || 0)
  const minVisibleRemaining = Math.max(0, LOADING_MIN_VISIBLE_MS - elapsed)
  const delay = Math.max(LOADING_HIDE_DELAY_MS, minVisibleRemaining)

  hideTimerId = globalThis.setTimeout(() => {
    hideTimerId = null
    if (pendingRequests.value === 0) {
      hideNow()
    }
  }, delay)
}

function beginGlobalLoading() {
  pendingRequests.value += 1
  if (hideTimerId) {
    globalThis.clearTimeout(hideTimerId)
    hideTimerId = null
  }
  scheduleShowIfNeeded()
}

function endGlobalLoading() {
  pendingRequests.value = Math.max(0, pendingRequests.value - 1)
  if (pendingRequests.value === 0) {
    scheduleHideIfNeeded()
  }
}

export {
  pendingRequests,
  isGlobalLoading,
  isGlobalLoadingVisible,
  beginGlobalLoading,
  endGlobalLoading,
}
